import { render } from "./document_approval.vue?vue&type=template&id=d200248e&scoped=true"
import script from "./document_approval.js?vue&type=script&lang=js"
export * from "./document_approval.js?vue&type=script&lang=js"

import "./document_approval.vue?vue&type=style&index=0&id=d200248e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d200248e"]])

export default __exports__